<div class="auth-card">
	<div class="image">
		<img
			ngSrc="/static/images/auth/auth-banner.png"
			fill
			priority="1"
			alt=""
		/>
	</div>
	<form
		class="auth-form"
		[formGroup]="credentials"
	>
		<img
			ngSrc="/static/images/auth/logo-dark.svg"
			height="36"
			width="133"
		/>
		<lib-button
			[leftSvgIcon]="github"
			[type]="ButtonType.Outlined"
			label="Login with GitHub"
		></lib-button>
		<lib-divider>or</lib-divider>
		<lib-input-text
			formControlName="email"
			placeholder="Email"
			label="Email"
			defaultValue=""
		/>
		<lib-input-text
			formControlName="password"
			placeholder="Password"
			type="password"
			label="Password"
			defaultValue=""
		/>
		<lib-button
			[loading]="true"
			(click)="submit()"
			label="Log In"
		></lib-button>
		<lib-button
			[type]="ButtonType.Secondary"
			label="Forgot password?"
		></lib-button>
		<lib-divider> Don't have an account </lib-divider>
		<lib-button
			[type]="ButtonType.Secondary"
			routerLink="/signup"
			label="Sign Up"
		>
		</lib-button>
	</form>
</div>
